<template>
  <main class="page-logs page-main__wrapper organizationPage">
    <!-- 面包屑 -->
    <div class="breadcrumb">
      <a href="javascript:void(0)" @click="$_goTo('listComponent')">运营商管理</a>
      <span class="split">/</span>
      <span class="active">组织架构</span>
    </div>

    <el-tabs class="logs-tabs" v-model="currentTab">
      <el-tab-pane label="默认组织" name="basic">
        <basic-brand :platformKey="platformKey" :provinces="provinces"></basic-brand>
      </el-tab-pane>

      <el-tab-pane label="自定义组织" name="custom">
        <custom-brand :platformKey="platformKey" :provinces="provinces"></custom-brand>
      </el-tab-pane>
    </el-tabs>
  </main>
</template>

<script>
import basicBrand from "./basic";
import customBrand from "./custom";
import { platform } from 'os';
export default {
  name: "merchants-organization",
  props: {
    contData: { type: Object, default: {} }
  },
  data() {
    return {
      currentTab: "basic",
      platformKey: '',
      provinces: [],
    };
  },
  components: {
    basicBrand,
    customBrand
  },
  async created(){
    this.platformKey = this.contData.platformKey;
    // 获取省数据
    this.isLoading = true;
    let result = await this.$service.post("getRegionData", {
      level: 'province',
      parentRegionCodeId: -1
    });
    this.provinces = result.data.concat([]);
    this.isLoading = false;
  },
  methods: {
    $_goTo(name){
      this.$emit('changeTab', {
        name,
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.page-logs.page-main__wrapper {
  height: 100%;
  position: relative;
  margin: 20px 16px 24px 20px;
}
.breadcrumb{
  padding-top: 0;
}
/deep/ .logs-tabs {
  position: relative;
  height: calc(100% - 21px);
  padding-top: 20px;
  .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 20px;
    border-bottom: 1px solid #f2f2f2;
    .el-tabs__nav-wrap {
      overflow: hidden;
      margin-bottom: -1px;
      position: relative;
    }
  }
  .el-tabs__nav {
    float: left;
    position: relative;
    white-space: nowrap;
    transition: transform 0.3s;
    z-index: 2;
  }
  .el-tabs__item {
    height: 40px;
    width: 120px;
    border-bottom: 3px solid transparent;
    margin-left:6px;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    list-style: none;
    font-size: 16px;
    font-weight: 500;
    color: #898989;
    position: relative;
    cursor: pointer;
    &.is-active {
      color: #384e8c;
      border-bottom-color: #384e8c;
    }
    &:focus,
    &:focus:active {
      outline: none;
    }
    &:nth-child(2) {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }

  .el-tabs__content {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 80px;
    overflow: hidden;
  }
  .el-tab-pane {
    height: 100%;
  }
}
/deep/ .el-scrollbar{
  &:active .el-scrollbar__bar, &:focus .el-scrollbar__bar, &:hover .el-scrollbar__bar {
    opacity: 1;
    -webkit-transition: opacity 340ms ease-out;
    transition: opacity 340ms ease-out;
  }
  .el-scrollbar__bar.is-vertical{
    bottom: 14px;
    .el-scrollbar__thumb{
      background:#909EB1;
    }
  }
  .el-scrollbar__bar.is-horizontal{
    .el-scrollbar__thumb{
      background:#909EB1;
    }
  }
}
</style>